import { render, staticRenderFns } from "./PropertyManager.vue?vue&type=template&id=77c528d8&"
import script from "./PropertyManager.vue?vue&type=script&lang=js&"
export * from "./PropertyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports